module.exports = __webpack_public_path__ + "img/send-documents--icon.32d40292.svg";